import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface HeartIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const HeartIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: HeartIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4558 12.7507C21.5147 10.7488 21.5147 7.50319 19.4558 5.50135C17.397 3.4995 14.0588 3.49958 12 5.50142C9.94109 3.49958 6.60301 3.49958 4.54415 5.50142C2.48528 7.50326 2.48528 10.7489 4.54415 12.7507C4.55132 12.7577 4.55851 12.7647 4.56571 12.7716L12 20L19.4558 12.7507Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default HeartIcon
